<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :search.sync="search"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
    >
      <template slot="communityIdSearch">
        <el-select
          v-model="search.communityId"
          filterable
          style="width: 100%"
          placeholder="请选择管理区域"
        >
          <el-option v-for="item in nodes" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="subjectIdSearch">
        <el-select v-model="search.subjectId" filterable placeholder="请选择收费科目">
          <el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="nameSearch">
        <el-input
          v-model="search.name"
          type="text"
          maxlength="20"
          show-word-limit="true"
          placeholder="请输入收费名称"
        ></el-input>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openDialog()"
          :disabled="disableAddBtn"
          v-if="permissionList.addBtn"
          >新 增
        </el-button>
      </template>
      <!-- <template slot="menuRight"> menuRight </template> -->
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" icon="el-icon-view" @click="openDialog(scope.row.id)"
          >查看</el-button
        >
        <el-button
          v-if="scope.row.status == 1"
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="status(0, scope.row.id)"
          >停用</el-button
        >
        <el-button
          v-if="scope.row.status == 0"
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="status(1, scope.row.id)"
          >启用</el-button
        >
      </template>
      <!-- 自定义列 -->
      <template slot="communityId" slot-scope="scope">{{ findNode(scope.row.communityId) }}
      </template>
      <template slot="subjectId" slot-scope="scope">{{ scope.row.subjectName }}
      </template>
      <template slot="feeWay" slot-scope="scope">{{ findDictValue(scope.row.feeWay, dicts.fee_standard_cal_way) }}
      </template>
      <template slot="price1" slot-scope="scope">{{ handleShowPrice(scope.row) }}
      </template>
      <template slot="price2" slot-scope="scope">{{ handleShowPrice2(scope.row) }}
      </template>
      <template slot="cycle" slot-scope="scope">{{ handleShowCycle(scope.row) }}
      </template>
    </avue-crud>
    <el-dialog
      :visible.sync="addVisible"
      :modal-append-to-body="false"
      width="60%"
      :title="viewId ? '查看' : '新增'"
    >
      <Add
        v-if="addVisible"
        @closeDialog="closeDialog"
        :dicts="dicts"
        :nodes="nodes"
        :subjects="subjects"
        :id="viewId"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Add from './add';
import {
  getList,
  getDict,
  getNode,
  getSubject,
  statusChange,
} from '@/api/v4ward/fee-standard/index';
export default {
  components: { Add },
  data() {
    return {
      viewId: '',
      disableAddBtn: true,
      addVisible: false,
      search: {},
      subjects: [],
      nodes: [],
      basebankaccount_view: false,
      basebankaccount_edit: false,
      basebankaccount_delete: false,
      basebankaccount_add: false,
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        // menuPosition: 'center',
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: false,
        // indexLabel: '序号',
        align: 'center',
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        searchMenuSpan: 6,
        // selection: false,
        // columnBtn: false,
        // span: 6,
        column: [
          {
            label: '管理区域',
            prop: 'communityId',
            searchslot: true,
            search: true,
            slot: true,
            searchSpan: 6,
          },
          {
            label: '收费科目',
            prop: 'subjectId',
            searchslot: true,
            search: true,
            slot: true,
            searchSpan: 6,
          },
          {
            label: '收费名称',
            prop: 'name',
            searchslot: true,
            search: true,
            searchSpan: 6,
          },
          {
            label: '计费方式',
            prop: 'feeWay',
            slot: true,
          },
          {
            label: '单价',
            prop: 'price1',
            slot: true,
          },
          {
            label: '指定金额',
            prop: 'price2',
            slot: true,
          },
          {
            label: '收费周期',
            prop: 'cycle',
            slot: true,
          },
          {
            label: '备注',
            span: 6,
            prop: 'remark',
          },
        ],
      },
      data: [],
      dicts: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.fee_standard_add, false),
      };
    },
  },
  created() {
    this.loadDicts();
    this.loadNodes();
    this.loadSubjects();
  },
  methods: {
    handleShowPrice(item) {
      try {
        let res = '';
        if (item.feeWay == '1') {
          res +=
            item.feePrice +
            '元 / m² .' +
            this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
        } else if (item.feeWay == '2') {
          // res +=
          //   item.feePrice + '元 .' + this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
        } else if (item.feeWay == '3') {
          if (item.pricingModel == '1') {
            res +=
              item.feePrice +
              '元 / ' +
              this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
          } else {
            res = '';
          }
        } else if (item.feeWay == '99') {
          if (item.pricingModel == '1') {
            res +=
              item.feePrice +
              '元 / ' +
              this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
          } else {
            res = '';
          }
        }
        return res;
      } catch (err) {
        console.log('handleShowPrice err==>', err);
        return '';
      }
    },
    handleShowCycle(item) {
      try {
        let res = '';
        if (item.cycleType == '2') {
          res = '一次性支付';
        }
        if (item.cycleUnit && item.cycleNum) {
          res += '每';
          res += this.findDictValue(item.cycleUnit, this.dicts.fee_standard_cycle_unit);
          res += '收';
          res += item.cycleNum;
          res += '次';
        }
        return res;
      } catch (err) {
        return '';
      }
    },
    handleShowPrice2(item) {
      let res = '';
      if (item.feeWay == '2') {
        console.log('item==>', item);
        res +=
          item.feePrice + '元 / ' + this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
      }
      return res;
    },
    openDialog(id) {
      this.viewId = id;
      this.addVisible = true;
    },
    closeDialog(refresh) {
      this.addVisible = false;
      if (refresh) this.onLoad();
    },
    loadDicts() {
      //圆整方式,计费方式,定价模式,支付周期,周期单位,账单生成颗粒,违约金起算日期(应收日期),收费精度,算费费率单位,不足月计算方式,不足月天数定义,收费仪表大类,收费仪表小类
      const dictCodes = [
        'fee_standard_round_way',
        'fee_standard_cal_way',
        'fee_standard_pricing_model',
        'fee_standard_cycle_start_rule',
        'fee_standard_cycle_type',
        'fee_standard_cycle_unit',
        'fee_standard_bill_generate_rule',
        'fee_standard_delay_start_type',
        'fee_standard_precision',
        'fee_standard_unit',
        'fee_standard_less_month_way',
        'fee_standard_less_month_days_way',
        'fee_standard_meter_big',
        'fee_standard_meter_big_small',
      ];
      let promises = [];
      dictCodes.forEach((item) => {
        promises.push(getDict({ code: item }));
      });
      Promise.all(promises).then((resArr) => {
        let dicts = {};
        resArr.forEach((item, index) => {
          let key = dictCodes[index];
          dicts[key] = item.data;
        });
        this.dicts = dicts;
        this.disableAddBtn = false;
        console.log('this.dicts==>', this.dicts);
      });
    },
    loadNodes() {
      getNode().then((res) => {
        console.log('res getNode==>', res);
        this.nodes = res.data;
        if (this.nodes.length > 0) {
          this.$set(this.search, 'communityId', this.nodes[0].id);
        }
        this.onLoad();
      });
    },
    loadSubjects() {
      getSubject().then((res) => {
        this.subjects = res.data;
        // this.search.subjectId = this.subjects[0].id
        console.log('this.subjects==>', this.subjects);
      });
    },
    status(status, id) {
      const params = {
        status,
        id,
      };
      this.$confirm('是否修改状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          statusChange(params).then((res) => {
            console.log('res==>', res);
            this.$message.success(res.msg);
            this.onLoad();
          });
        })
        .catch(() => {});
    },
    findNode(id) {
      let node = this.nodes.find((ele) => ele.id == id);
      return node ? node.title : '';
    },
    finSubject(id) {
      let subject = this.subjects.find((ele) => ele.id == id);
      return subject ? subject.name : '';
    },
    findDictValue(dictKey, dictData) {
      let res;
      if (!dictKey || !dictData || dictData.length == 0) {
        console.log('emoty==>');
        return '';
      }
      dictData.forEach((item) => {
        if (item.dictKey == dictKey) {
          res = item;
        }
      });
      return res.dictValue || '';
    },
    beforeOpen(done, type) {
      console.log('type', type);
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.search = Object.assign({}, this.search, { subjectId: '', name: '' });
      this.onLoad();
    },
    searchChange(params, done) {
      console.log('params==>', params);
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad();
    },
    onLoad() {
      console.log('onload==>');
      let params = this.search;
      params.current = this.page.currentPage;
      params.size = this.page.pageSize;
      getList(params).then((res) => {
        this.data = res.data.records;
        this.page.total = res.data.total;
      });
    },
  },
};
</script>

<style scoped>
</style>
